'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventConstants = function EventConstants() {
  _classCallCheck(this, EventConstants);
};

EventConstants.QuestionAnswerComponent = Object.freeze({
  TRASH: 'trash',
  ANSWERED: 'answered',
  UNANSWERED: 'unanswered',
  ALL: 'all',
  PRIVATE: 'private',
  QUESTION_PROMPT: 'Type your question here',
  TAB_ONE_TEXT: 'Answered Questions',
  TAB_TWO_TEXT: 'My Questions'
});
EventConstants.EventRegistrationTypeEnum = Object.freeze({
  SSO: 'SSO',
  REGISTRATION: 'REGISTRATION',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  TOKEN: 'TOKEN'
});
EventConstants.RegistrationLayoutEnum = Object.freeze({
  WIDE: 'WIDE',
  NARROW: 'NARROW'
});
EventConstants.RegistrationColorDefaults = Object.freeze({
  HEADER_BACKGROUND_COLOR: '#FFFFFF',
  PAGE_BACKGROUND_COLOR: '#FFFFFF',
  DESCRIPTION_COLUMN_BACKGROUND_COLOR: '#FFFFFF',
  DESCRIPTION_COLUMN_FONT_COLOR: '#000000',
  REGISTRATION_COLUMN_BACKGROUND_COLOR: '#FFFFFF',
  REGISTRATION_COLUMN_FONT_COLOR: '#000000',
  REGISTRATION_COLUMN_BUTTON_COLOR: '#ff9800',
  REGISTRATION_COLUMN_BUTTON_FONT_COLOR: '#000000'
});
EventConstants.QuestionTypeEnum = Object.freeze({
  SINGLE: {
    type: 'single',
    text: 'Single-Select'
  },
  MULTIPLE: {
    type: 'multiple',
    text: 'Multi-Select'
  }
});
EventConstants.ScreenTypesEnum = Object.freeze({
  LOBBY: 'lobby',
  EXIT: 'exit',
  EVENT: 'event',
  TEAM_VIEW: 'teamView'
});
EventConstants.ScreenNamesEnum = Object.freeze({
  LOBBY_NAME: {
    default: 'Default Lobby Layout',
    standard: 'Untitled Lobby Layout'
  },
  EXIT_NAME: {
    default: 'Default Exit Layout',
    standard: ''
  },
  EVENT_NAME: {
    default: 'Default Event Layout',
    standard: 'Untitled Event Layout'
  },
  TEAM_VIEW_NAME: {
    default: 'Default View',
    standard: 'Untitled View'
  }
});
EventConstants.ControlRoomComponentsEnum = Object.freeze({
  POLLS: {
    name: 'Polls',
    type: 'polls',
    classScope: 'singleton'
  },
  AV: {
    name: 'Audio/Video',
    type: 'av',
    classScope: 'singleton'
  },
  QA: {
    name: 'Q & A',
    type: 'qa',
    classScope: 'singleton'
  },
  TEXT: {
    name: 'Text',
    type: 'text',
    classScope: 'multiple'
  },
  IMAGE: {
    name: 'Image',
    type: 'image',
    classScope: 'multiple'
  },
  SLIDESHOW: {
    name: 'Slideshow',
    type: 'slideshow',
    classScope: 'singleton'
  },
  SURVEYS: {
    name: 'Surveys',
    type: 'surveys',
    classScope: 'singleton'
  },
  IFRAME: {
    name: 'iFrame',
    type: 'iframe',
    classScope: 'multiple'
  },
  TIMER: {
    name: 'Timer',
    type: 'timer',
    classScope: 'singleton'
  },
  TELEPROMPTER: {
    name: 'Q&A Teleprompter',
    type: 'teleprompter',
    classScope: 'singleton'
  },
  VIDEO_PLAYER: {
    name: 'Video Player',
    type: 'video_player',
    classScope: 'singleton'
  }
});
EventConstants.IframeUserDataValuesEnum = Object.freeze({
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  FIRST_NAME_LAST_NAME: 'First & Last Name',
  EMAIL: 'Email',
  COMPANY: 'Company',
  TRUE: 'true',
  FALSE: 'false',
  ZERO: '1',
  ONE: '0'
});
EventConstants.EventStatusEnum = Object.freeze({
  CREATING: 'CREATING',
  COMPLETED: 'COMPLETED',
  STAGED: 'STAGED',
  ARCHIVED: 'ARCHIVED',
  SCHEDULED: 'SCHEDULED',
  RUNNING: 'RUNNING',
  calendarCompletedStatus: ['COMPLETED', 'STAGED'],
  completedEventStatuses: ['COMPLETED', 'STAGED', 'ARCHIVED'],
  afterCompletedStatuses: ['STAGED', 'ARCHIVED'],
  checkEventStarted: function checkEventStarted(status) {
    if (status === 'SCHEDULED') {
      return false;
    } else {
      return true;
    }
  },
  hasEventCompleted: function hasEventCompleted(status) {
    if (status === 'RUNNING' || status === 'SCHEDULED' || status === 'CREATING') {
      return false;
    } else {
      return true;
    }
  }
});
EventConstants.EventType = Object.freeze({
  LIVE: 'live',
  AUTOCAST: 'autocast',
  PRERECORDED: 'prerecorded'
});
EventConstants.START_EVENT_DELAY = 15;
exports.default = EventConstants;